interface Props {
    htmlFor: string;
    label: string;
    description?: string;
    isEditMode?: boolean;
}

const FormField = ({ htmlFor, label, description, isEditMode = false }: Props) => {
    return (
        <>
            <label htmlFor={htmlFor} className={`block text-base ${isEditMode ? 'font-semibold' : 'font-medium'} text-light-black font-poppins`}>
                {label}
            </label>
            {description && <p className={` ${isEditMode ? 'text-base' : 'text-[12px] '} text-light-black/80 font-normal mb-2 font-poppins`}>{description}</p>}
        </>
    );
};

export default FormField;
